import { useEffect } from 'react';

const DOMAIN = 'https://bodybycc.fr';

/**
 * Sets canonical URL and OG meta tags. Cleans up on unmount.
 */
export function useCanonical(path: string) {
  useEffect(() => {
    const url = `${DOMAIN}${path}`;

    // Canonical
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', url);

    // OG URL
    let ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement | null;
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', url);
  }, [path]);
}

/**
 * Sets dynamic OG and Twitter meta tags for a page.
 */
export function usePageMeta(opts: { title: string; description: string; ogImage?: string }) {
  useEffect(() => {
    document.title = opts.title;

    const setMeta = (attr: string, key: string, value: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };

    setMeta('name', 'description', opts.description);
    setMeta('property', 'og:title', opts.title);
    setMeta('property', 'og:description', opts.description);
    setMeta('name', 'twitter:title', opts.title);
    setMeta('name', 'twitter:description', opts.description);

    if (opts.ogImage) {
      setMeta('property', 'og:image', opts.ogImage);
      setMeta('name', 'twitter:image', opts.ogImage);
    }
  }, [opts.title, opts.description, opts.ogImage]);
}
